import React, { useState, useEffect } from 'react'
import SearchIcon from '../../../images/NavBarImages/Multiply_50px.png';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';



const DetailsForm = ({ ItemDetails, ShowDetails, LanguageID, ItemSize, SelectedItemSize, setSelectedItemSize, ThemeColor, ItemNote, setItemNote
              }) => {


  const [selectedSize, setSelectedSize] = useState(
    ItemSize.find((size) => size.defaultSelect === 1) || ItemSize[0]

  );

  const handleChange = (event) => {
    const selectedSizeName = event.target.value;
    const newSelectedSize = ItemSize.find((size) => size.sname === selectedSizeName);
    setSelectedSize(newSelectedSize);
    setSelectedItemSize(newSelectedSize);
    //  console.log(newSelectedSize)
  };

  useEffect(() => {
    setSelectedItemSize(ItemSize.find((size) => size.defaultSelect === 1) || ItemSize[0]);

  }, []);
  return (

    <div >

      {ItemDetails.map((item) => (

        <div style={{

          height: '55vh',
          overflowY: 'auto', // Enable vertical scrolling
          // Optional: Add some padding
          // Adjust the height as needed
          width: '100%',
        }} >



          <div className='col' style={{
            width: '100%', display: 'flex',
            flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 100 }}  >
              <button style={{
                border: 'none',
                background: 'rgba(200, 221, 221, 0.6)', // Transparent background
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.8)', // Fixed alpha in shadow
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                padding: '0',
                backdropFilter: 'blur(8px)', // This applies the blur
                WebkitBackdropFilter: 'blur(8px)', // For Safari support
              }} onClick={() => ShowDetails('Back', '')} type="button"> <img style={{ width: '30px', height: '30px' }} src={SearchIcon} /> </button>
            </div>
            <div className='row' style={{ width: '100%', height: '350px', display: 'flex', }}>
              <img src={item.imageUrl} alt="Logo" style={{ borderRadius: '10px', width: '100%', }} />
            </div>
            <div className='row' style={{
              width: '100%', backgroundColor: 'blue', position: 'absolute',
              top: '42vh'
              ,
              height: '30vh', // Adjust the height as needed
              width: '100%',
              borderRadius: '4% 4% 0% 0%',
              backgroundColor: 'white',
            }}>

              <div className='row' style={{ textAlign: 'end', marginTop: '10px', marginRight: '10px' }}>
                <label style={{ fontSize: '20px', fontWeight: 'bold', fontFamily: 'basheer' }}>{item.itemName}</label>
              </div>


              {ItemSize.length > 0 && (
                <div className='row' style={{ textAlign: 'right' }}>
                  <FormControl>

                    <RadioGroup
                      aria-labelledby="item-size-radio-group"
                      name="item-size-group"
                      value={selectedSize.sname}
                      onChange={handleChange}
                      style={{ display: "flex", flexDirection: "row", direction: "rtl" }}
                    >
                      {ItemSize.map((size) => (
                        <FormControlLabel
                          key={size.sname}
                          value={size.sname}
                          control={<Radio checked={selectedSize === size} />}
                          label={size.sPrice > 0 ? `${size.sname} + ${size.sPrice}` : size.sname}
                          style={{ textAlign: "right" }}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              )}


              {(item.itemMem != '' && item.itemMem != null) && (
                <div className='row' style={{ fontSize: '16px', textAlign: 'end', marginRight: '10px', marginLeft: '10px', fontWeight: 'bold' }}>


                  <label style={{ fontSize: '13px', fontFamily: 'basheer', color: '#A4B0B6' }}>( {item.itemMem} )</label>


                </div>
              )}
              <div className='row' style={{ fontSize: '16px', textAlign: 'end', fontWeight: 'bold', marginTop: '5px', marginRight: '10px', fontFamily: 'basheer', fontSize: '20px', color: `#${ThemeColor}`, display: 'flex', direction: 'rtl' }}>
                <div className='col'>
                  <label >{item.itemPrice.toLocaleString()} </label>
                  <label style={{ marginRight: '5px' }}> د.ع</label>
                </div>

              </div>

              <div  >

                <div className='row' style={{ fontSize: '16px', textAlign: 'end', marginRight: '10px', marginLeft: '10px', fontWeight: 'bold', marginTop: '5px' }}>


                  <label style={{ fontSize: '16px', fontFamily: 'basheer', color: 'black', }}>اي ملاحظات خاصة؟</label>


                </div>

                <TextField className='row' style={{ minWidth: '95%', backgroundColor: 'white', borderRadius: '30px', margin: '10px', direction: 'rtl', textAlign: 'center', fontFamily: 'basheer' }}
                  inputProps={{
                    style: {

                      fontFamily: 'basheer',

                    },
                  }}
                  placeholder='اكتب هنا' type='string' value={ItemNote} onChange={(e) => (setItemNote(e.target.value))} />


              </div>





              <div className='row' style={{ textAlign: 'end', margin: '10px' }}>


                {(LanguageID == 1 && item.itemDetails !== null) && (
                  <div>
                    <label style={{ direction: 'rtl', fontSize: '16pt', fontWeight: 'bold', display: 'flex', textAlign: 'end', marginBottom: '10px' }}>التفاصيل:</label>
                    <label style={{ fontSize: '12pt', }}>{item.itemDetails}</label>
                  </div>
                )}


              </div>





            </div>
          </div>









        </div>

      ))}

    </div>
  )
}


export default DetailsForm